// 根据环境判断使用本地还是生产环境地址
const isProduction = process.env.NODE_ENV === 'production';

// 本地开发环境配置
const LOCAL_WS_URL = 'ws://localhost:8088/websocket';
const LOCAL_BASEURL = 'http://localhost:8088/';

// 生产环境配置（自动获取当前域名，支持多域名绑定）
const PROD_WS_URL = `wss://${window.location.host}/websocket`;
const PROD_BASEURL = `https://${window.location.host}/`;


// 根据环境选择配置
const VUE_APP_WS_URL = isProduction ? PROD_WS_URL : LOCAL_WS_URL;
const VUE_APP_BASEURL = isProduction ? PROD_BASEURL : LOCAL_BASEURL;

export { VUE_APP_WS_URL, VUE_APP_BASEURL };